export default __webpack_public_path__ + "static/media/arrow.06fa7aad.webp";